import { render, staticRenderFns } from "./OrderedItems.vue?vue&type=template&id=6a4633a6&scoped=true&"
import script from "./OrderedItems.vue?vue&type=script&lang=ts&"
export * from "./OrderedItems.vue?vue&type=script&lang=ts&"
import style0 from "./OrderedItems.vue?vue&type=style&index=0&id=6a4633a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4633a6",
  null
  
)

export default component.exports